import React from 'react';

import { Auth0Provider } from '@auth0/auth0-react';

import { auth0Config, isAuth0Configured } from './auth0Config';

interface Props {
  children: React.ReactNode;
}

/**
 * Conditional Auth0Provider wrapper.
 *
 * If Auth0 is configured and enabled, wraps children with Auth0Provider.
 * Otherwise, renders children directly without the Auth0 context.
 * This allows the app to function normally when Auth0 is disabled.
 */
const Auth0ProviderWithConfig: React.FC<Props> = ({ children }) => {
  // If Auth0 is not configured, just render children without provider
  if (!isAuth0Configured()) {
    return <>{children}</>;
  }

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithConfig;
